
import FileResultCard from './FileResultCard.vue';
import MxModal from '@/components/global/MxModal.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BetaChip from '../BetaChip.vue';
import { FileFlagStatus,  MediaType, IFileEncoderConfigurationAnalysisResource } from '@/types/resource.types';

@Component({
    name: 'FileECA',
    components: {
        FileResultCard,
        MxModal,
        BetaChip
    }
})
export default class FileECA extends Vue {

    /* Props
    ============================================*/

    @Prop({type: Object, required: false})
    readonly eca: IFileEncoderConfigurationAnalysisResource;


    /* Computed
    ============================================*/
    
    get matchText(): string {
        if(this.eca?.type === 2) {
            return 'ECA Match';
        }
        return 'No ECA Match';
    }

    get matchType(): string {
        if(this.eca?.type === 2) {
            return 'success';
        }
        return '';
    }

}

